import React from "react";
import loadable from "@loadable/component";

const Header = loadable(() =>
	import("@components/Dashboard/Pro/Funnel/Shared/Header")
);

export default ({ children, ...props }) => (
	<React.Fragment>
		<Header label={"Weekly budget"} {...props} />
		{children}
	</React.Fragment>
);
